import { render, staticRenderFns } from "./ChangguanDetails.vue?vue&type=template&id=b4178d78&scoped=true"
import script from "./ChangguanDetails.vue?vue&type=script&lang=js"
export * from "./ChangguanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4178d78",
  null
  
)

export default component.exports